<template>
  <v-row no-gutters class="tw-justify-stretch tw-mb-10">
    <v-col class="tw-flex tw-flex-col tw-items-center tw-gap-3">
      <v-chip color="primary" size="x-small" rounded class="tw-rounded-md">
        {{ $t('exceededResourcesInfoCard.freePlan') }}
      </v-chip>
      <v-card
        variant="outlined"
        color="primary"
        rounded
        class="tw-rounded-lg tw-opacity-50 tw-flex tw-flex-col tw-items-center tw-py-3 tw-px-2 tw-gap-2 tw-shadow-lg tw-shadow-primary-500/20 tw-w-[125px] tw-grow"
      >
        <div
          v-if="type === 'consultations'"
          class="tw-grid tw-grid-cols-2 tw-gap-2 tw-w-full tw-h-full tw-items-center"
        >
          <div
            v-for="i in consultationsLimit"
            :key="i"
            class="tw-flex tw-justify-center"
          >
            <v-icon
              icon="mdi-check"
              class="tw-text-primary-400 tw-text-xs tw-bg-primary-400/10 tw-rounded-full tw-size-3"
            />
          </div>
        </div>

        <v-img
          v-else-if="type === 'recordingTime'"
          src="@/assets/hourglass.svg"
          width="34"
          height="60"
        />
      </v-card>
    </v-col>

    <v-col class="tw-flex tw-flex-col tw-items-center tw-gap-3">
      <v-chip
        variant="flat"
        color="primary"
        size="x-small"
        rounded
        class="tw-rounded-md"
      >
        {{ $t('exceededResourcesInfoCard.proPlan') }}
      </v-chip>
      <v-card
        variant="outlined"
        color="primary"
        rounded
        class="tw-rounded-lg tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-3 tw-px-0 tw-gap-3 tw-shadow-lg tw-shadow-primary-500/20 tw-w-[125px] tw-grow"
      >
        <v-img
          src="@/assets/daai-lock-key-checked.svg"
          width="72"
          class="tw-h-11 tw-max-h-11"
        />

        <v-list
          class="pro-list tw-p-0 tw-gap-1 tw-text-left tw-text-primary-500 tw-text-[10px]"
        >
          <v-list-item
            v-for="item in proListItems"
            class="tw-grid-cols-[14px_1fr_auto] tw-px-[15px]"
          >
            <template #prepend>
              <v-icon
                icon="mdi-check"
                class="tw-text-[8px] tw-text-primary-400 tw-mt-1"
              />
            </template>
            <span>{{ item }}</span>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
  </v-row>

  <p
    class="tw-text-xl tw-text-slate-600 tw-mb-6"
    v-html="
      $t('exceededResourcesInfoCard.limitReached.message', {
        type: $t(
          `exceededResourcesInfoCard.limitReached.${
            type === 'consultations' ? 'consultations' : 'hours'
          }`,
        ),
      })
    "
  ></p>
</template>

<script setup>
import { useI18n } from '@/composables/useI18n'
import { useUserStore } from '@/stores/user'
import { CONSULTATIONS_LIMIT } from '@/constants/resourceLimits'

const { t } = useI18n()
const userStore = useUserStore()
const { limits: userPlanLimits } = storeToRefs(userStore)

const consultationsLimit = computed(
  () => userPlanLimits.value?.consultationsPerMonth ?? CONSULTATIONS_LIMIT,
)

defineProps({
  type: {
    type: String,
    default: 'consultations',
  },
})

const proListItems = computed(() => {
  return [
    t('exceededResourcesInfoCard.proListItems.unlimitedConsultations'),
    t('exceededResourcesInfoCard.proListItems.unlimitedModelCustomization'),
  ]
})
</script>

<style lang="scss" scoped>
:deep() {
  .pro-list {
    .v-list-item {
      &__prepend,
      &__content {
        align-self: flex-start;
      }
    }
  }
}
</style>
